<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(client.client_id ? 'Edit Client: ' + client.client_id : 'New Client') + ' :: MeritEHS'"/>

            <h4 class="py-2 mb-2">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/jobsites#clients`">
                            <i class="fa fa-address-book-o"></i> Clients
                        </router-link>
                    </li>
                    <template v-if="client_id">
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                            <router-link :to="`/clients/view/${client_id}`">
                                {{ client.client_name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                            <i class="fa fa-edit"></i> Edit
                        </li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                            <i class="fa fa-plus"></i> New
                        </li>
                    </template>
                    <li class="ml-3 d-none d-md-inline-block">
                        <button type="button" class="btn btn-sm btn-success" v-on:click="saveClient(this)" :disabled="saving">
                            <span v-if="client_id">Update</span>
                            <span v-else>Create</span>
                            Client
                        </button>
                    </li>
                </ol>
            </h4>

            <div class="d-block d-md-none mt-3 mb-3">
                <button type="button" class="btn btn-sm btn-success" v-on:click="saveClient(this)" :disabled="saving">
                    <span v-if="client_id">Update</span>
                    <span v-else>Create</span>
                    Client
                </button>
            </div>

            <div class="row mt-4 mb-4">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header">Client Details</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.client_name}">Client Name:</label>
                                <div class="col-sm-8">

                                    <b-form-input type="text" v-model="client.client_name" :class="{'is-invalid': errors.client_name}" placeholder="Enter Client Name"></b-form-input>

                                    <span v-if="errors.client_name" class="text-danger">
                                        <span v-for="error in errors.client_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.contact_name}">Contact Name:</label>
                                <div class="col-sm-8">

                                    <b-form-input type="text" v-model="client.contact_name" :class="{'is-invalid': errors.contact_name}" placeholder="Enter Contact Name"></b-form-input>

                                    <span v-if="errors.contact_name" class="text-danger">
                                        <span v-for="error in errors.contact_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.contact_phone}">Contact Phone:</label>
                                <div class="col-sm-8">

                                    <b-form-input type="text" v-model="client.contact_phone" :class="{'is-invalid': errors.contact_phone}" placeholder="Enter Contact Phone Number"></b-form-input>

                                    <span v-if="errors.contact_phone" class="text-danger">
                                        <span v-for="error in errors.contact_phone">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.contact_email}">Contact Email:</label>
                                <div class="col-sm-8">

                                    <b-form-input type="email" v-model="client.contact_email" :class="{'is-invalid': errors.contact_email}" placeholder="Enter Contact Email"></b-form-input>

                                    <span v-if="errors.contact_email" class="text-danger">
                                        <span v-for="error in errors.contact_email">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">Client Address</div>
                        <div class="card-body">
                            <b-form-textarea v-model="client.client_address" placeholder="Enter Client Address"></b-form-textarea>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">Client Notes</div>
                        <div class="card-body">
                            <b-form-textarea v-model="client.client_notes" placeholder="Enter Client Notes"></b-form-textarea>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveClient(this)" :disabled="saving">
                <span v-if="client_id">Update</span>
                <span v-else>Create</span>
                Client
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                client_id: this.$route.params.id,
                client: {},
                divisions: {},
                errors: {},
            }
        },

        methods: {

            getClient: function() {
                //Get the data
                this.$http
                    .get('clients/edit' + (this.client_id ? '/' + this.client_id : ''))
                    .then(response => {
                        //Set all the data
                        this.client = response.data.client;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveClient: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('clients/edit' + (this.client_id ? '/' + this.client_id : ''), this.client)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Client Saved');

                    //Return to main list?
                    this.$router.push('/clients/view/' + response.data.client_id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the Clients
            this.getClient();
        }
    }
</script>
